import React from "react";
import { Accordion, Box, VStack, HStack, Text, Icon, SimpleGrid } from "@chakra-ui/react";
import { Balancer } from "react-wrap-balancer";
import { PRICING_FEATURES, SUPPORT_HOURS_USES } from "./constants";

const PlanFeatures = () => {
  return (
    <Box mb={4} w="full">
      <Accordion.Root defaultValue={["item-0"]} multiple>
        <Accordion.Item value="item-0" borderRadius="md" border="none">
          <Accordion.ItemTrigger p={4} w="fit-content">
            <Box fontWeight="bold" fontSize="lg" borderRadius="md" color="primary.200">
              {"*What's Included in Every Microsoft 365 Service Plan"}
            </Box>
            <Accordion.ItemIndicator />
          </Accordion.ItemTrigger>

          <Accordion.ItemContent>
            <Box
              pb={4}
              border="1px solid"
              borderColor="gray.200"
              boxShadow="lg"
              borderRadius="md"
            >
              <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} gap={6}>
                {PRICING_FEATURES.map((feature, index) => (
                  <HStack align="start" gap={4} key={index}>
                    <Icon as={feature.icon} boxSize={6} color="blue.500" mt={1} />
                    <VStack align="start" gap={1}>
                      <Text fontWeight="550" color="text.100">
                        {feature.label}
                      </Text>
                      <Text fontSize="md" color="text.100">
                        {feature.desc}
                      </Text>
                    </VStack>
                  </HStack>
                ))}
              </SimpleGrid>

              <HStack mt={4} align="start" gap={4}>
                <Icon as={SUPPORT_HOURS_USES.icon} boxSize={6} color="blue.500" />
                <VStack align="start">
                  <Text fontWeight="550" color="text.100">
                    {SUPPORT_HOURS_USES.label}
                  </Text>
                  <Balancer>
                    <Text fontSize="md" color="text.100">
                      {SUPPORT_HOURS_USES.desc}
                    </Text>
                  </Balancer>
                </VStack>
              </HStack>
            </Box>
          </Accordion.ItemContent>
        </Accordion.Item>
      </Accordion.Root>
    </Box>
  );
};

export default PlanFeatures;
